import { Controller } from "@hotwired/stimulus"

// Handles click-based answering for single_choice, multiple_choice, true_false, poll.
// Submits payload via fetch to the controller's submit_url.
export default class extends Controller {
  static values = {
    questionId: Number,
    submitUrl: String,
    mode: String
  }

  connect() {
    this.selected = new Set()
    this.submitted = false
  }

  select(event) {
    if (this.submitted) return
    event.preventDefault()
    const button = event.currentTarget
    const optionId = button.dataset.optionId

    if (this.modeValue === "multiple") {
      if (this.selected.has(optionId)) {
        this.selected.delete(optionId)
        button.classList.remove("bg-blue-50", "border-blue-500")
      } else {
        this.selected.add(optionId)
        button.classList.add("bg-blue-50", "border-blue-500")
      }
    } else {
      // single_choice, true_false, poll — immediate submit
      this.doSubmit(optionId)
    }
  }

  submit(event) {
    // Manual submit button handler (for multiple_choice)
    if (event) event.preventDefault()
    this.doSubmit(null)
  }

  async doSubmit(optionId) {
    if (this.submitted) return
    this.submitted = true

    let payload
    if (this.modeValue === "multiple") {
      payload = { selected_ids: Array.from(this.selected) }
    } else if (this.modeValue === "true_false") {
      payload = { selected: optionId === "true" }
    } else {
      payload = { selected_id: optionId }
    }

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ question_id: this.questionIdValue, payload: payload })
      })
      if (!response.ok) throw new Error(`Submit failed: ${response.status}`)
      this.element.classList.add("opacity-50", "pointer-events-none")
    } catch (error) {
      console.error("Quiz answer submit failed:", error)
      this.submitted = false
    }
  }
}
